import _ from 'lodash';

export function getUploadVideoKeysByStatus(videoKeysGroupByState: unknown, statusKey: string): string[] {
  return _.get(videoKeysGroupByState, statusKey, []);
}

export function getAmountOfUploadingVideos(amountOfQueued: number, amountOfUploading: number): number {
  return amountOfQueued + amountOfUploading;
}
